import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "@/lib/utils/localStorage";
import { isNullable } from "@/lib/utils/typeof";

export const createLocalStorageCache = <T>(key: string, defaultValue: T) => {
  let value = defaultValue;
  let initialized = false;

  return {
    get(): T {
      if (!initialized) {
        value = getLocalStorage<T>(key) ?? defaultValue;
        initialized = true;
      }

      return value;
    },
    set(next: T): void {
      value = next;
      initialized = true;

      if (isNullable(next)) {
        removeLocalStorage(key);
      } else {
        setLocalStorage(key, next);
      }
    },
    clear(): void {
      value = defaultValue;
      initialized = false;
      removeLocalStorage(key);
    },
  };
};
